import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrap-stepper" }
const _hoisted_2 = { class: "c-stepper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "c-stepper_circle" }
const _hoisted_5 = { class: "c-stepper_number" }
const _hoisted_6 = { class: "c-stepper__title" }



type TItem = {
  key: number
  titleCircle: string
  title: string
  iconDone: string
}

interface IPropsStepper {
  items: TItem[],
  value: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Horizontal',
  props: {
    items: null,
    value: null
  },
  emits: ["onChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onChange', item: TItem): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: TItem[],
  value: number
}





const onChange = (item) => {
  emit('onChange', item)
}

const classStepper = (item: TItem): string => {
  if (item.key === props.value) {
    return 'active'
    // eslint-disable-next-line no-else-return
  } else if (item.key < props.value) {
    return 'done'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(`c-stepper__item ${classStepper(item)}`),
          key: item.key,
          onClick: ($event: any) => (onChange(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.titleCircle), 1)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})